import { msgTypes } from "constants/msgTypes";
import { RouteType } from "constants/RouteType";
import { InvoiceManagementModel } from "model/screensModels/InvoiceManagementModel";
import { PaginatorModel } from "model/utilModels/PaginatorModel";
import { RequestModel } from "model/utilModels/RequestModel";
import { AuthService } from "services/auth/AuthService";

export class InvoiceManagementService {
  // constructor() { }

  static getInvoiceList = async (requestBody: InvoiceManagementModel) => {
    const url = RouteType.ADMIN + RouteType.INVOICE_MANAGEMENT;
    const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
    return response;
  };

 static addInvoice = async (requestBody: InvoiceManagementModel) => {
    const url = RouteType.ADMIN + RouteType.INVOICE_MANAGEMENT + RouteType.STORE;
    const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
    return response;
  };

  static deleteInvoice = async (requestBody: InvoiceManagementModel) => {
    const url = RouteType.ADMIN + RouteType.INVOICE_MANAGEMENT + RouteType.DELETE;
    const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
    return response;
  };

  static invoiceManagementstatus = async (requestBody: InvoiceManagementModel) => {
    const url = RouteType.ADMIN + RouteType.INVOICE_MANAGEMENT_STATUS_COUNT;
    const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
    return response;
  };

  static countUnreadInvoice = async (requestBody: InvoiceManagementModel) => {
    const url = RouteType.ADMIN + RouteType.INVOICE_MANAGEMENT + RouteType.UNREAD_COUNT;
    const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
    return response;
  };

  static invoiceMarkAsRead = async (requestBody: InvoiceManagementModel) => {
    const url = RouteType.ADMIN + RouteType.INVOICE_MANAGEMENT + RouteType.MARK_AS_READ;
    const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
    return response;
  };

  static unreadInvoiceList = async (requestBody: InvoiceManagementModel) => {
    const url = RouteType.ADMIN + RouteType.INVOICE_MANAGEMENT + RouteType.UNREAD_INVOICE_LIST;
    const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
    return response;
  };

  static getInvoiceNumber = async () => {
    const url = RouteType.ADMIN + RouteType.INVOICE_MANAGEMENT + RouteType.GET_INVOICE;
    const response = AuthService.postCryptoRequest(url, msgTypes.EMPTY_STR);
    return response;
  };


  static getInvoiceListByCompanyId = async (requestBody: RequestModel) => {
    const url = RouteType.ADMIN + RouteType.INVOICE_MANAGEMENT + RouteType.FILTER_INVOICE;
    const response = AuthService.postCryptoRequest(url, JSON.stringify(requestBody));
    return response;
  };

}